import { useCallback, useState } from 'react';

/**
 * A generic hook for managing controlled or uncontrolled state.
 */
export const useControlledState = <T>(
  controlledValue: T | undefined,
  defaultValue: T
) => {
  const [internalValue, setInternalValue] = useState<T>(defaultValue);
  const isControlled = controlledValue !== undefined;
  const value = isControlled ? controlledValue : internalValue;

  const setValue = useCallback(
    (newValue: T | ((prevValue: T) => T)) => {
      if (!isControlled) {
        setInternalValue(newValue);
      }
    },
    [isControlled]
  );

  return {
    value,
    setValue,
  };
};
